module.exports = __webpack_public_path__ + "img/arboretum.62f0f6e8.webp";